import React, {Component} from 'react';

class ApiFetch extends Component {
    static API_PROTOCOL = window.location.protocol
    static API_HOST = "ourt-ai.work/api";
    static CHECKOUT_API_HOST = "checkout.ourt-ai.work/api";
    static IMG_HOST = "img.ourt-ai.work";
    static VIDEO_HOST = "video.ourt-ai.work";
    static API_THUMB_EXT = ".webp"
    get(url) {
      let res = fetch(url,{credentials:"include", mode: 'cors'})
      return res
    }
    post(url,param) {
      return fetch(url, {
        method: 'POST',
        mode: 'cors',
        credentials:"include",
        body: JSON.stringify(param)
      })
    }
    put(url,param) {
      return fetch(url, {
        method: 'PUT',
        mode: 'cors',
        credentials:"include",
        body: JSON.stringify(param)
      })
    }
    delete(url,param) {
      return fetch(url, {
        method: 'DELETE',
        mode: 'cors',
        credentials:"include",
        body: JSON.stringify(param)
      })
    }
    fileUpload(url,formData) {
      let fd = formData

      return fetch(url, {
        method: 'POST',
        mode: 'cors',
        credentials:"include",
        body: fd
      }).then(function(response) {
        return response
      }, function(error) {
        // エラー内容
        console.log(error)
        return error
      })
    }
    formDataUpload(url,formData) {
      let fd = formData

      return fetch(url, {
        method: 'POST',
        mode: 'cors',
        credentials:"include",
        body: fd
      })
    }
  }

export default ApiFetch
